import { errorOptions } from './error-condition-options-list';
export class BaseErrorLabelHelper {
    constructor(translate) {
        this.translate = translate;
    }
    getErrorOption(errorFilter) {
        const { errorType, errorOption } = errorFilter.value;
        const selectedErrorOption = errorOptions.find((item) => {
            const match = !!(item === null || item === void 0 ? void 0 : item.value) && item.value.errorOption === errorOption && item.value.errorType === errorType;
            return match;
        });
        return selectedErrorOption;
    }
}
//# sourceMappingURL=error-label-base.helper.js.map